import { ErrorBoundary } from "./features/shared/ErrorBoundary";
import { Error500Page } from "./pages/Error500Page";

type RootErrorBoundaryProps = { children: React.ReactNode };

export const RootErrorBoundary = (props: RootErrorBoundaryProps) => {
  const { children } = props;
  return (
    <ErrorBoundary
      render={(state) => (state.hasError ? <Error500Page /> : children)}
    />
  );
};
